module.exports = __webpack_public_path__ + "img/pick_card.8b6e2877.png";